import angular from 'angular';

import Component from './SubTables.component';
import './SubTables.scss';

export default angular.module('petroCloud.subTables', [])
  .component(Component.name, Component)
  .name;
